import {
    IFiltroGestaoContaChatFechado,
    IGestaoAtendimentos,
    INumeroInfo,
} from "../../../Interfaces/HelpDesk/GestaoAtendimentos/GestaoAtendimentosInterface";
import {
    IMensagemAtivaEmMassa,
    IMensagemTemplate,
    IValorVariavel,
} from "../../../Interfaces/HelpDesk/Equipes/Atendimento/AtendimentoInterfaces";
import Axios from "../../Config/API";
import Service from "../../Service";
import { IClienteEmLoteFilter } from "../../../Interfaces/Geral/GestaoClientes/GestaoClientesInterfaces";
export async function ListarContaChatService(
    requestBody: IFiltroGestaoContaChatFechado
) {
    return Service(
        Axios.post<Array<IGestaoAtendimentos>>(
            `/helpdesk/contachat/listarcontachat`,
            requestBody
        )
    );
}
export async function ListarMensagensTemplate() {
    return Service(
        Axios.get<Array<IMensagemTemplate>>(
            `/helpdesk/templatemensagemativa/ListarTemplateMensagemAtiva`
        )
    );
}
export async function BuscarInformacoesNumero(NR_TELEFONE: string) {
    const response = await Axios.get<INumeroInfo>(
        `/helpdesk/twilio/buscarinformacoesnumero?NR_TELEFONE=${NR_TELEFONE}`
    )
        .then((response) => {
            return response;
        })
        .catch((err) => {
            throw err.response;
        });
    return response;
}
export async function ObterValoresVariaveisMensagemAtiva(
    nrCliente: string,
    idTemplate: number
) {
    try {
        const response = await Axios.post<Array<IValorVariavel>>(
            `/helpdesk/templatemensagemativa/obtervaloresvariaveismensagemativa?nrCliente=${nrCliente}&idTemplate=${idTemplate}`
        );
        return response;
    } catch (error) {
        console.error(
            "Erro ao obter valores de variáveis de mensagem ativa:",
            error
        );
    }
}
export async function EnviarMensagemAtivaEmMassaService(
    idDocumentoTemplate: number,
    requestBody: Array<IMensagemAtivaEmMassa>
) {
    return Service(
        Axios.post(
            `/helpdesk/twilio/enviarmensagemativaemmassa?idDocumentoTemplate=${idDocumentoTemplate}`,
            requestBody
        )
    );
}

export async function FiltrarEmpreendimentoFilaService(
    LST_ID_EMPREENDIMENTO: number[],
    FL_FILA_ATENDIMENTO: boolean
) {
    return Service(
        Axios.post<Array<string>>(
            `/helpdesk/twilio/filtraratendimentosabertos`,
            {
                LST_ID_EMPREENDIMENTO,
                FL_FILA_ATENDIMENTO,
            }
        )
    );
}

export async function GerarModeloTemplateService(
    requestBody: IClienteEmLoteFilter
) {
    return Service(
        Axios.post<Blob>(
            `/home/clienteemlote/gerarmodelotemplate`,
            requestBody,
            { responseType: "blob" }
        )
    );
}
